<div class="modal-header d-flex align-items-center mb-2">
    <h5 class="modal-title px-2 d-flex align-items-center">
        {{ formInputData?.label | translateTokenisedString }}
    </h5>
    <button class="close" (click)="cancelClicked()">
        <wdx-icon icon="xmark" size="lg"></wdx-icon>
    </button>
</div>

<div class="flex-1 grid overflow-hidden">
    <div
        class="h-100 d-flex flex-column"
        [ngClass]="{
            'g-col-6': selectedTypeFormId,
            'g-col-12': !selectedTypeFormId,
        }"
    >
        <div class="flex-0 grid mb-1 p-2 align-items-center">
            @let views = views$ | ngrxPush;
            <ng-select
                class="g-col-6 g-col-lg-3 g-col-xl-2"
                [items]="views"
                [clearable]="false"
                [(ngModel)]="selectedView"
                (ngModelChange)="viewChanged()"
                [readonly]="
                    formInputData?.lookupConfiguration?.viewCode ||
                    views?.length === 1
                "
            >
                <ng-template ng-option-tmp let-item="item">
                    {{ item.name | translateTokenisedString }}
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                    {{ item.name | translateTokenisedString }}
                </ng-template>
            </ng-select>

            <ng-container
                *ngTemplateOutlet="
                    typeSelectTemplate;
                    context: {
                        classes:
                            'd-block d-lg-none g-col-6 g-col-lg-3 g-col-xl-2',
                    }
                "
            ></ng-container>

            <wdx-search-input
                class="g-col-12 g-col-lg-6 g-col-xl-8 h-100"
                [inputGroupClasses]="'h-100'"
                [autoFocus]="true"
                (wdxChanged)="searchChange($event)"
            ></wdx-search-input>

            <ng-container
                *ngTemplateOutlet="
                    typeSelectTemplate;
                    context: {
                        classes:
                            'd-none d-lg-block g-col-6 g-col-lg-3 g-col-xl-2',
                    }
                "
            ></ng-container>
            <ng-template #typeSelectTemplate let-classes="classes">
                <ng-select
                    [class]="classes"
                    bindValue="type"
                    [items]="formInputData?.lookupSources"
                    [readonly]="formInputData?.lookupSources?.length === 1"
                    [clearable]="false"
                    [ngModel]="selectedType"
                    (ngModelChange)="typeChanged($event)"
                >
                    <ng-template ng-option-tmp let-item="item">
                        {{
                            'ENTITY_' + item.type + '_SINGULAR'
                                | uppercase
                                | translateTokenisedString
                        }}
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                        {{
                            'ENTITY_' + item.type + '_SINGULAR'
                                | uppercase
                                | translateTokenisedString
                        }}
                    </ng-template>
                </ng-select>
            </ng-template>
            @if (value?.length) {
                <div class="g-col-12 form-group d-flex align-items-center">
                    <div class="text-nowrap me-2">
                        {{ value?.length }}
                        {{
                            'FORM_ADVANCED_LOOKUP_SELECTED'
                                | translateTokenisedString
                        }}
                    </div>
                    <clmi-lookup-selected-items
                        class="form-control"
                        [rows]="value"
                        (deleteItem)="deleteItem($event)"
                    ></clmi-lookup-selected-items>
                </div>
            }
        </div>

        <wdx-ag-grid-entity-table
            class="flex-1 mx-2"
            [gridOptions]="gridOptions"
            [columnDefs]="columnDefs"
            [entityType]="selectedType"
            [searchText]="searchText"
            [queryExpressions]="queryExpressions"
            [initialSort]="initialSort"
            (agGridApi)="setGridApi($event)"
            (tableDataLoaded)="tableDataLoaded()"
        ></wdx-ag-grid-entity-table>
    </div>

    @if (selectedTypeFormId) {
        <wdx-ff-form-container
            class="form-container-panel g-col-6 h-100 overflow-hidden"
            [formId]="selectedTypeFormId"
            [stylingOptions]="{
                hideCancelButton: true,
            }"
            [modalCloseOnSaveSuccess]="false"
            [initialisationParams]="initialisationParams"
            [isQuickCreate]="true"
            (formEvent)="onFormEvent($event)"
        >
            <ng-container wdxFFCustomActions>
                <button
                    [wdxButton]="WdxButtonStyle.OutlinePrimary"
                    (click)="closeCreateNewForm()"
                >
                    {{ 'CANCEL_BTN' | translateTokenisedString }}
                </button>
            </ng-container>
        </wdx-ff-form-container>
    }
</div>

<div
    class="dialog-footer d-flex align-items-center justify-content-end mt-4 mb-5 mx-2"
>
    <button
        class="me-2"
        data-cy="lookup-modal-cancel-button"
        [wdxButton]="WdxButtonStyle.OutlinePrimary"
        (click)="cancelClicked()"
    >
        {{ 'CANCEL_BTN' | translateTokenisedString }}
    </button>

    @let currentTypeFormId = typeFormIds[selectedType];
    @if (isActivityType) {
        <div ngbDropdown container="body" class="me-2 d-inline-block">
            <button
                [wdxButton]="WdxButtonStyle.OutlinePrimary"
                ngbDropdownToggle
                [disabled]="
                    selectedTypeFormId ||
                    formInputData.lookupCreationMode ===
                        LookupCreationMode.ExistingOnly
                "
                [ngbTooltip]="
                    selectedTypeFormId &&
                    ('ERROR_CLOSE_FORM_BEFORE_CONFIRMING_MODAL'
                        | translateTokenisedString)
                "
            >
                {{ 'CREATE_NEW' | translateTokenisedString }}
                <wdx-icon [icon]="ICON_ADD"></wdx-icon>
            </button>
            <div ngbDropdownMenu>
                @for (
                    activityForm of activityQuickCreateForms;
                    track activityForm.activityType
                ) {
                    <button
                        ngbDropdownItem
                        (click)="openActivityForm(activityForm)"
                    >
                        {{
                            activityForm.labelKey
                                | translateTokenisedString
                        }}
                    </button>
                }
            </div>
        </div>
    } @else {
        <button
            class="me-2"
            [wdxButton]="WdxButtonStyle.OutlinePrimary"
            [disabled]="
                selectedTypeFormId ||
                !currentTypeFormId ||
                formInputData.lookupCreationMode ===
                    LookupCreationMode.ExistingOnly
            "
            [ngbTooltip]="
                selectedTypeFormId
                    ? ('ERROR_CLOSE_FORM_BEFORE_CONFIRMING_MODAL'
                      | translateTokenisedString)
                    : !currentTypeFormId &&
                      ('ERROR_NO_FORM_ASSIGNED_TO_LOOKUP_TYPE'
                          | translateTokenisedString
                              : {
                                    LookupType:
                                        'ENTITY_' + selectedType + '_SINGULAR'
                                        | uppercase
                                        | translateTokenisedString,
                                })
            "
            (click)="toggleCreateNewForm()"
        >
            {{ 'CREATE_NEW' | translateTokenisedString }}
            <wdx-icon [icon]="ICON_ADD"></wdx-icon>
        </button>
    }

    <button
        data-cy="lookup-modal-ok-button"
        [wdxButton]="WdxButtonStyle.Primary"
        [disabled]="selectedTypeFormId"
        [ngbTooltip]="
            selectedTypeFormId &&
            ('ERROR_CLOSE_FORM_BEFORE_CONFIRMING_MODAL'
                | translateTokenisedString)
        "
        [placement]="['top-right', 'auto']"
        (click)="okClicked()"
    >
        {{ 'OK_BTN' | translateTokenisedString }}
    </button>
</div>
